module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/search-alt-c473d2fc58df54cf44371eab0c6e0adc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/search-alt.svg
// module id = +lH1
// module chunks = 24